export const jpAdminRegisterForm = {
  CG41title: 'アルムナイ登録フォーム設定確認',
  CG41text1: '下記が、招待URLから登録する',
  CG41text2: 'アルムナイ自身に入力してもらう項目となります。',
  CG41requiredText: '氏名（漢字）、氏名（カナ）、表示名、メールアドレス、生年月日、現職情報（所属先、職種、所属期間）',
  CG41addText: '在籍していた部署名、在籍期間、在籍時社員ID、在籍時メールアドレス、在籍時氏名（漢字）',
  CG40unnecessary: '不要',
  CG40required: '必須',
  CG40any: '任意',
  CG40updateFailed: '更新に失敗しました',
  CG42title: 'アルムナイ登録フォーム設定完了',
  CG41currentPosition: '現職情報（所属先、職種、所属期間）',
  CG40Yelloop_Check_info1: '以下の項目はプール型では必須入力です。',
  CG40Yelloop_Check_info2: '再入社意欲、特に知りたい情報',
  CG40copyingformsettings: 'フォーム設定のコピー',
  CG40copyfieldfromotherform: '他のフォーム設定から項目をコピーできます。',
  CG40cannotcopyfromcurrent: '編集中の内容はコピーできません。',
  CG40btncopy: 'コピー',
  CG40titlecopyconfirm: 'アルムナイ登録フォームコピー確認',
  CG40copyfromhere: 'からコピーします。',
  CG40notechangeswilldiscarded: '現在編集している内容は破棄されますのでご注意ください。',
  CG40handlecopy: 'コピーする',
  CG40titlecopysuccess: 'アルムナイ登録フォームコピー完了',
  CG40copied: 'コピーしました。',
  CG40selectformcopy: 'コピーするフォームを選択してください',
}
